export default __webpack_public_path__ + "static/media/nomnomai-logo.f90b4ba2.webp";